export default "__VITE_ASSET__7xyZ8HIN__"